import React from 'react';
import Head, { Props as HeadProps } from '~/App/shared/components/Head';
import { useTranslation } from '~/Locale';
import VerificationWrapper from './components/VerificationWrapper';
import styled from 'styled-components';
import ComponentPadding from '~/App/shared/components/Layout/ComponentPadding';

const Container = styled(ComponentPadding)`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

interface Props {
  isModal?: boolean;
  data?: HeadProps;
}

const Verification = ({ data, isModal }: Props) => {
  const { t } = useTranslation();

  if (isModal) {
    return <VerificationWrapper isModal={isModal} />;
  }

  return (
    <Container>
      <Head {...data} title={t('PAGE_TITLES.VERIFICATION')} />

      <div>
        <VerificationWrapper isModal={isModal} />
      </div>
    </Container>
  );
};

export default Verification;
